import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useDispatch, useSelector } from 'react-redux';
import { AI_GENERATOR_PHOTO_TAB_LIST } from '../../../../config/dataConfig/FJAIPhotoGeneratorData.js';
import { useEffect } from 'react';
import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage.js';
import FJActionAIPhotoEditor from '../../../../redux/action/FJActionAIPhotoEditor.js';
import FJAIPhotoGeneratorRight from '../view/FJAIPhotoGeneratorRight.jsx';
import FJAppConstant from '../../../../constants/FJAppConstant.js';

const FJAIPhotoGeneratorRightContainer = () => {
    useLocalStore();
    const tabIndex = useSelector(state => state.aiPhotoGenerator.tabIndex);
    const tabType = AI_GENERATOR_PHOTO_TAB_LIST[tabIndex].value;
    const dispatch = useDispatch();

    const isShowPresetImageBox1 = useSelector(state => state.aiPhotoEditor.isShowPresetImageBox);
    const isShowPresetImageBox2 = useSelector(state => state.textToImage.isShowPresetImageBox);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);

    const _onRetry = id => {
        if (tabType === FJAppConstant.AI_PHOTO_EDITOR) {
            dispatch(FJActionAIPhotoEditor.retryAction(id));
        } else if (tabType === FJAppConstant.TEXT_TO_IMAGE) {
            dispatch(FJActionTextToImage.retryTaskAction(id));
        }
    };

    return (
        <FJAIPhotoGeneratorRight
            tabType={tabType}
            onRetry={_onRetry}
            isShowPresetImageBox={
                tabType === FJAppConstant.AI_PHOTO_EDITOR ? isShowPresetImageBox1 : isShowPresetImageBox2
            }
            headerTabIndex={headerTabIndex}
        />
    );
};
export default FJAIPhotoGeneratorRightContainer;
